<h2 mat-dialog-title>{{ labels.LOG }}</h2>
<mat-dialog-content class="mat-typography">
    <div class="log-view" [innerHTML]="log"></div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="custom-buttom">
        {{ labels.CLOSE }}
    </button>
</mat-dialog-actions>

